import { useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { TransitionSource } from '../types/teikihoan/commonDefinition';
import { usePageNavigate } from '../hooks/usePageNavigate';
import { openSystem, getMainte } from '../logics/apiLogic';

export const useMenu = () => {
  const location = useLocation();
  const { inputMailPage, resevationPage } = usePageNavigate();
  const params = location.state;
  const [isMaintenance, setIsMaintenance] = useState<boolean>(false);

  /****************************************
   * メンテナンスフラグの取得
   ****************************************/
  const JudgeMaintenance = async () => {
    const isMainteApi = await getMainte();
    const isMainte = isMainteApi.is_maintenance;
    setIsMaintenance(stringToBoolean(isMainte));
  };

  useLayoutEffect(() => {
    JudgeMaintenance();
  }, []);

  /****************************************
   * 文字列をbooleanに変換
   ****************************************/
  const stringToBoolean = (value: string | null | undefined) => {
    // null、undefined は false
    if (!value) {
      return false;
    }
    // 小文字にして判定
    return value.toLowerCase() === 'true' || value === '1';
  };

  /****************************************
   * 他システムのURL取得、リダイレクト
   ****************************************/
  const getURLandRedirect = async () => {
    const param = {
      mailaddress: params.mailaddress ?? '',
      source: params.source,
      gyomu: params.gyomu,
      token: params.token,
      step: 0,
      prepage: params.prepage ?? '',
      customer_no: '',
      kyokyusaki_no: '',
      function: params.gyomu,
      event_sbt: params.event_sbt,
      guid: params.guid ?? '', //2024.09 COMTEC kawaji ADD
      display_mode: params.display_mode ?? '', //2026.09 NEOTEX kawaji ADD
    };
    const result = await openSystem(param);
    if (result.result === 0) {
      window.location.replace(result.redirect_url);
    }
  };

  /****************************************
   * 新規予約ボタンクリック
   ****************************************/
  const onHandleNewClick = async () => {
    switch (params.gyomu) {
      case 'teikihoan':
      case 'heikaisen': //2025.01 COMTEC kawaji ADD
      case 'heisen': //2025.07 COMTEC kawaji ADD
      case 'kaisen': //2025.07 COMTEC kawaji ADD
        if (params?.source === TransitionSource.Line) {
          //LINEの場合はそのまま各システムへ遷移
          getURLandRedirect();
        } else {
          //HP,うぇぶひだまりの場合はメールアドレス入力画面へ遷移
          inputMailPage(params);
        }
        break;

      case 'event':
        getURLandRedirect();
        break;
    }
  };

  const onHandleConfirmClick = () => {
    resevationPage({ ...params, prepage: 'menu' });
  };

  return {
    isMaintenance,
    onHandleNewClick,
    onHandleConfirmClick,
  };
};
